import { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ProfilePage() {
  const { user, setUser, logout } = useAuth();
  const [username, setUsername] = useState(user?.username || "");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password && password !== confirm) {
      toast.error("كلمة المرور غير متطابقة");
      return;
    }
    const payload = {};
    if (username.trim() && username.trim() !== user.username) payload.username = username.trim();
    if (password) payload.password = password;
    if (Object.keys(payload).length === 0) {
      toast.info("لا توجد تغييرات");
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.put(`/users/${user.id}`, payload);
      const newUser = { ...user, username: data.username };
      setUser(newUser);
      localStorage.setItem("agha_user", JSON.stringify(newUser));
      toast.success("تم حفظ التغييرات. يرجى تسجيل الدخول من جديد");
      setPassword(""); setConfirm("");
      if (payload.password) {
        setTimeout(() => logout(), 800);
      }
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto px-6 py-12">
      <h1 className="text-4xl font-display font-extrabold text-zinc-900 mb-2 tracking-tight">الصفحة الشخصية</h1>
      <p className="text-sm text-zinc-600 mb-8">يمكنك تغيير اسم المستخدم وكلمة المرور الخاصة بحسابك</p>

      <form onSubmit={submit} className="bg-white border border-zinc-200 rounded-2xl p-8 elevated-card space-y-5" data-testid="profile-form">
        <div>
          <Label htmlFor="uname">اسم المستخدم</Label>
          <Input
            id="uname"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            data-testid="profile-username-input"
            className="mt-1.5 py-5"
          />
        </div>
        <div>
          <Label htmlFor="pwd">كلمة المرور الجديدة</Label>
          <Input
            id="pwd"
            type="password"
            placeholder="اتركها فارغة للإبقاء على الحالية"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="profile-password-input"
            className="mt-1.5 py-5"
          />
        </div>
        <div>
          <Label htmlFor="pwd2">تأكيد كلمة المرور</Label>
          <Input
            id="pwd2"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            data-testid="profile-confirm-input"
            className="mt-1.5 py-5"
          />
        </div>
        <Button
          type="submit"
          disabled={saving}
          data-testid="profile-save-btn"
          className="bg-teal-700 hover:bg-teal-800 w-full py-6 text-base font-bold"
        >
          {saving ? "جاري الحفظ..." : "حفظ التغييرات"}
        </Button>
      </form>
    </div>
  );
}
